<template>
  <div id="contenedor-main-contrato-inventario">
    <!-- ToolBar -->
      <tool-bar
        v-on:nuevoInventario="nuevoInventario">
      </tool-bar>
      <!-- Listado -->
      <template v-if="listadoInventarios.length > 0">
        <v-card
        flat>
        <v-card-text>
          <listado
            :listadoInventarios="listadoInventarios">
          </listado>
        </v-card-text>
      </v-card>
      </template>
      <template v-else>
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay inventarios registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
      <!-- Registrar nuevo inventario -->
      <v-dialog
        v-if="mostrarRegistrarInventario"
        v-model="mostrarRegistrarInventario"
        width="650"
        persistent>
        <registrar-inventario
          :idContrato="$route.params.idContrato"
          v-on:cerrar="cerrarVentana">
        </registrar-inventario>
      </v-dialog>
      <!-- Editar inventario -->
      <v-dialog
        v-if="esteInventario"
        v-model="mostrarEditarInventario"
        width="650"
        persistent>
        <editar-inventario
          :idContrato="$route.params.idContrato"
          :inventarioEditar="esteInventario"
          v-on:cerrar="cerrarVentana">
        </editar-inventario>
      </v-dialog>
      <!-- Eliminar inventario -->
      <v-dialog
      v-if="esteInventario"
      v-model="mostrarEliminarInventario"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
        <eliminar-inventario
          :idContrato="$route.params.idContrato"
          :contratoInventarioEliminar="esteInventario"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_INVENTARIO from '@/graphql/querys/administracion/contratos/contrato/inventario/contratoInventario.gql';
import ToolBar from './ToolBar.vue';
import RegistrarInventario from '@/components/administracion/contratos/contrato/inventarios/Agregar.vue';
import EditarInventario from '@/components/administracion/contratos/contrato/inventarios/Editar.vue';
import EliminarInventario from '@/components/administracion/contratos/contrato/inventarios/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoInventario',
  components: {
    ToolBar,
    Listado,
    RegistrarInventario,
    EditarInventario,
    EliminarInventario,

  },
  apollo: {
    contratoInventario: {
      query: CONTRATO_INVENTARIO,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  data() {
    return {
      mostrarRegistrarInventario: false,
      mostrarEditarInventario: false,
      mostrarEliminarInventario: false,
      esteInventario: null,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarRegistrarInventario = false;
      this.mostrarEditarInventario = false;
      this.mostrarEliminarInventario = false;
      this.esteInventario = null;
    },
    nuevoInventario() {
      this.mostrarRegistrarInventario = true;
    },
  },
  computed: {
    listadoInventarios() {
      if (!this.contratoInventario) return [];
      return this.contratoInventario
        .slice()
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
    },
  },
  mounted() {
    eventBus.$on('editar-inventario-contrato', (inventarioContrato) => {
      this.esteInventario = inventarioContrato;
      this.mostrarEditarInventario = true;
    });
    eventBus.$on('eliminar-inventario-contrato', (inventarioContrato) => {
      this.esteInventario = inventarioContrato;
      this.mostrarEliminarInventario = true;
    });
  },
};
</script>

<style lang="scss">

</style>
